import { esFutura } from '../../utils/fechas';

export { nombreSede } from '../../utils/turnos';

export function estadoInfo(estado) {
  const value = String(estado || '').toLowerCase();
  if (value === 'confirmado') return { tone: 'success', label: 'Confirmado' };
  if (value === 'reservado') return { tone: 'warning', label: 'Reservado' };
  if (value === 'realizado') return { tone: 'neutral', label: 'Realizado' };
  if (value === 'cancelado') return { tone: 'danger', label: 'Cancelado' };
  return { tone: 'neutral', label: estado || '—' };
}

const TRES_MESES_MS = 1000 * 60 * 60 * 24 * 92;

export function filtrarProximos(turnos) {
  return turnos
    .filter((t) => esFutura(t.fechaYHora) && String(t.estado || '').toLowerCase() !== 'cancelado')
    .sort((a, b) => new Date(a.fechaYHora) - new Date(b.fechaYHora));
}

export function filtrarPasados(turnos) {
  const ahora = Date.now();
  return turnos
    .filter((t) => !esFutura(t.fechaYHora) && ahora - new Date(t.fechaYHora).getTime() <= TRES_MESES_MS)
    .sort((a, b) => new Date(b.fechaYHora) - new Date(a.fechaYHora));
}